import React, { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import useAuth from '../../Hooks/useAuth';

const ManageOrders = ({order,deleteBtn}) => {
    const {user} = useAuth();
    
    return (
        <>
        {
            order.orderEmail === user.email ? 
            <tr>
                <td><img className="orderImage" src={order.img} alt="" /></td>
                <td>{order.name}</td>
                <td>{order.title}</td>
                <td>{
                    order.status === false ?
                    <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
                        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">PENDING</label>
                    </div>
                    : 
                    <div className="form-check form-switch">
                        <input className="form-check-input" type="checkbox" id="flexSwitchCheckDefault" />
                        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">OK</label>
                    </div>
                    }
                </td>
                <td><Button variant='danger' onClick={()=>deleteBtn(order._id)} >DElETE</Button></td>
            </tr>
            : null
        }
        </>
    );
};

export default ManageOrders;